<nes-heading tag="h2" class="nes-mb-3" size="800">
  {{ "AANVRAGEN_STEP.TITLE" | translate }}
</nes-heading>
<p class="nes-mb-8">
  {{ "AANVRAGEN_STEP.SUBTITLE" | translate }}
</p>

<form [formGroup]="form" (ngSubmit)="onSubmit()">
  <ng-container *ngFor="let field of question.fields">
    <div [ngSwitch]="field.type">
      <div *ngSwitchCase="'input'" class="nes-mb-6">
        <nes-input
          [nesId]="field.name"
          nesFormControl
          required
          [error]="hasError(field.name, 'required')"
          [value]="form.get(field.name)?.value"
          [label]="field.label ? (field.label | translate) : ''"
          [helpText]="field.subLabel ? (field.subLabel | translate) : ''"
          [formControlName]="field.name"
        >
        </nes-input>
        <nes-error-message
          *ngIf="hasError(field.name, 'required')"
          class="error-message"
        >
          {{ "VALIDATION.INPUT.REQUIRED" | translate }}
        </nes-error-message>
      </div>

      <div *ngSwitchCase="'radio'">
        <nes-selectable-group
          (nesOnGroupChange)="onSelectableRadioChange($event)"
          nes-id="nes-selectable-group"
          label="nes-selectable-group"
          class="nes-mb-6"
        >
          <nes-heading class="nes-mb-3" size="400">
            {{ field.label ? (field.label | translate) : "" }}
          </nes-heading>

          <div
            *ngFor="let option of field.options; let i = index"
            class="nes-mb-3"
          >
            <nes-selectable-radio
              required
              nesFormControl
              [nesId]="option.value"
              [name]="field.name"
              [error]="hasError(field.name, 'required')"
              [label]="option.label | translate"
              [formControlName]="field.name"
              [checked]="form.get(field.name)?.value === option.value"
              [value]="option.value"
            >
              <div slot="header">
                <nes-text color="text-default" weight="bold">
                  {{ option.label | translate }}
                </nes-text>
              </div>
            </nes-selectable-radio>
          </div>
          <nes-error-message
            *ngIf="hasError(field.name, 'required')"
            class="error-message"
          >
            {{ "VALIDATION.RADIO.REQUIRED" | translate }}
          </nes-error-message>
        </nes-selectable-group>
      </div>
    </div></ng-container
  >
  <nes-button
    (nesOnClick)="onSubmit()"
    [variant]="'AANVRAGEN_STEP.BUTTON.VARIANT' | translate"
  >
    {{ "AANVRAGEN_STEP.BUTTON.LABEL" | translate }}</nes-button
  >
</form>
